import { render } from "./ModalChatRules.vue?vue&type=template&id=a1d28c32&scoped=true"
import script from "./ModalChatRules.vue?vue&type=script&lang=js"
export * from "./ModalChatRules.vue?vue&type=script&lang=js"

import "./ModalChatRules.vue?vue&type=style&index=0&id=a1d28c32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1d28c32"]])

export default __exports__